var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { useContext, useEffect, useState } from 'react';
import { RemoteStatus } from '../Remote';
import useComputedValues from './useComputedValues';
import { TransferSpeedsContext } from './useTransferSpeeds';
import useHolidays from './useHolidays';
import { useIsMount, isFirstOrLastBusinessDayFrequency, getNextFirstOrLastBusinessDay, } from '../utils';
var useDeliveryDatePrePop = function (_a) {
    var minDeliveryDate = _a.minDeliveryDate;
    var _b = __read(useState(null), 2), prePopDate = _b[0], setPrePopDate = _b[1];
    var _c = __read(useState(false), 2), waitForSpeeds = _c[0], setWaitForSpeeds = _c[1];
    var transferSpeeds = useContext(TransferSpeedsContext).transferSpeeds;
    var _d = useComputedValues(), fromAccount = _d.fromAccount, toAccount = _d.toAccount, transferType = _d.transferType, frequency = _d.frequency;
    var isMount = useIsMount();
    var federalHolidays = useHolidays().federal;
    useEffect(function () {
        if (isMount)
            return;
        if (transferType === null) {
            setPrePopDate(null);
            return;
        }
        if (transferType === 'EXTERNAL') {
            setWaitForSpeeds(true);
            return;
        }
        setPrePopDate(minDeliveryDate);
    }, [fromAccount, toAccount, transferType, frequency]);
    useEffect(function () {
        if (waitForSpeeds && transferSpeeds.status === RemoteStatus.Loaded) {
            var newDeliveryDate = isFirstOrLastBusinessDayFrequency(frequency)
                ? getNextFirstOrLastBusinessDay({
                    federalHolidays: federalHolidays,
                    date: minDeliveryDate,
                    frequency: frequency,
                })
                : minDeliveryDate;
            setPrePopDate(newDeliveryDate);
            setWaitForSpeeds(false);
        }
    }, [transferSpeeds, waitForSpeeds, minDeliveryDate]);
    return prePopDate;
};
export default useDeliveryDatePrePop;
//# sourceMappingURL=useDeliveryDatePrePop.js.map